<template>
  <section :class="{ container: true, 'container-mobile': isMobile }">
    <header class="header">
      <div class="logo">
        <div class="left">
          <router-link class="img-a" to="/">
            <img
              :width="isMobile ? '340px' : '500px'"
              src="../../static/icon/banner12.png"
            />
          </router-link>
        </div>
      </div>
    </header>
    <div class="content">
      <div class="al-container mx-auto  mb-10 min-h-[800px] ">
        <div class="text-slate-500"></div>
        <div>
          <article class="leading-9  " style="color: #555;">
            <h2
              class=" text-title  leading-tight text-[#000] text-[1.8rem] md:text-[2.5rem] font-bold my-10 hover:text-[#DC192B]"
            >
              {{ currentNews.title }}
            </h2>
            <div class="text-date text-left text-slate-500 text-[2rem]  my-10 ">
              {{ currentNews.date }}
            </div>
            <div v-if="currentNews.imgageList" class="text-center">
              <div
                v-for="(item, index) in currentNews.imgageList"
                :key="index"
                class="text-center"
              >
                <img
                  class=" img-v rounded-lg w-auto h-auto max-h-80 lg:max-h-[28rem] m-auto md:max-w-3xl"
                  :src="item.img"
                />
              </div>
            </div>

            <div
              class=" content-v md:block h-auto  leading-6 text-slate-900  mt-10 info  m-auto "
              v-html="currentNews.desc.join('<br/>') || ''"
            ></div>
          </article>
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="mess">
        <div class="foo-left">
          <div class="zx">
            <div class="more-download">
              <div></div>
            </div>
          </div>
          <div class="more"></div>
          <div class="thr">
            <p class="foot-p">
              地址：香港北角英皇道351-353號銀輝中心5/F，C&D室
            </p>
            <p class="foot-p">
              {{ $t("message.Home_PhoneNumber") }}：852-2887 2678
            </p>
            <p class="foot-p">{{ $t("message.Home_Fax") }}：852-2887 2618</p>
            <p class="foot-p">
              {{ $t("message.Home_Email") }}：bili2678@gmail.com
            </p>
          </div>
        </div>
      </div>

      <div class="bottom-info">
        <span
          >香港莊氏璧立宗親會 版權所有 HONGKONG CHUANGS BILI CLANSMEN
          ASSOCIATION</span
        >
      </div>
    </footer>
  </section>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      newsListTw: [
        {
          id: 1,
          title:
            "「東江綠韻．南沙同行」生態研學之旅圓滿舉行 助港澳青年探索大灣區綠色發展",
          nav: "",
          date: "2026-04-29",
          imgageList: [
            {
              img: require("../../static/news/20260714/wxtp_20260714114124_84_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114124_85_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114124_86_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114124_87_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114124_88_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114124_89_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114137_90_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114137_91_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114137_92_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114137_93_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114137_94_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114138_95_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114138_96_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114138_97_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114138_98_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114138_99_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114138_100_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114139_101_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114139_102_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114139_103_157.jpg"),
              alt: ""
            },
            {
              img: require("../../static/news/20260714/wxtp_20260714114139_104_157.jpg"),
              alt: ""
            }
          ],
          tagList: ["Technology", "Education", "Internet", "Media"],
          desc: [
            "【活動回顧】「東江綠韻．南沙同行」生態研學之旅圓滿舉行 助港澳青年探索大灣區綠色發展",
            "",
            "2026年4月3日至4日，由香港莊氏璧立慈善基金有限公司主辦，並獲民政及青年事務局、青年發展委員會及政府資助計劃慷慨贊助的「東江綠韻．南沙同行」生態研學之旅於廣州南沙圓滿結束。本次活動專為12至35歲的香港青年而設，旨在透過實地考察與交流，讓青年深入了解大灣區的生態保育與科技發展，進壹步融入國家發展大局。",
            "",
            "東江綠韻：探索生態保育與可持續發展",
            "緊扣「東江綠韻」的主題，研習團深入了解南沙在環保與生態建設方面的卓越成果。青年們首先參觀了廣州環投南沙環保能源發電廠，認識現代化城市廢物處理與轉化能源的先進技術。隨後，行程轉至高新沙水庫及坦頭村紅樹林，讓團員實地考察水資源管理及濕地生態系統的保護工作。這些行程不僅提升了青年對國家生態文明建設的認識，更啟發了他們對綠色可持續發展的深刻思考。",
            "",
            "南沙同行：見證前沿科技與傳承歷史文化",
            "除了生態考察，研習團亦全方位探索了南沙的多元面貌。在科技領域，青年們走訪了小馬智行（Pony.ai），近距離體驗無人駕駛技術的創新應用，感受大灣區在智慧出行方面的領先地位。在歷史傳承方面，行程安排了參觀海戰博物館，讓青年透過豐富的歷史展品回顧近代史，從中培養家國情懷，增強民族自豪感。",
            "",
            "匯聚青年：分享交流共築未來",
            "經過兩日充實的實地考察，大會特別舉辦了總結分享會。在這個互動平臺上，香港青年踴躍發言，分享兩日研學之旅的深刻體會與所見所聞。透過深度的交流與對話，青年們不僅鞏固了行程中所學的知識，更拓寬了視野，為未來在大灣區的學習、就業及發展積累了寶貴的思想財富。",
            "",
            "總結與展望",
            "「東江綠韻．南沙同行」生態研學之旅不僅是壹次增廣見聞的考察，更是壹堂生動的國情教育課。未來，香港莊氏璧立慈善基金有限公司將繼續秉持培育青年的宗旨，策劃更多具深度的交流活動，引領香港青年把握大灣區的發展機遇。",
            "",
            "本次活動得以順利舉行，大會再次衷心感謝民政及青年事務局、青年發展委員會及政府資助計劃的鼎力支持，以及所有參與青年的熱情投入。期待未來見證更多香港青年在大灣區的舞臺上發光發熱！",
            ""
          ]
        }
      ],
      isMobile: false
    };
  },
  computed: {
    currentNews() {
      // this.$route.params.id
      return this.newsListTw.find(item => item.id == 1);
    }
  },
  mounted() {
    let curiWidth = document.body.clientWidth;
    console.log("curiWidth", curiWidth);
    if (curiWidth < 768) {
      this.isMobile = true;
    }
  }
};
</script>
<style scoped>
@import "./base.css";
.container {
  height: 100%;
  overflow-y: auto;
}
.content {
  width: 1104px;
  background: #fff;
  margin: 120px auto 100px auto;
}
.al-container {
  padding-top: 20px;
}
.al-container .text-date {
  font-size: 22px;
  margin: 20px 0;
}
.al-container .text-title {
  line-height: 1.25;
  font-size: 30px;
  text-align: center;
  margin: 50px 0;
}
.al-container .text-center {
  margin: 0 auto;
  text-align: center;
}
.al-container .img-v {
  max-width: 620px;
  width: auto;
}
.al-container .content-v {
  margin-top: 50px;
  font-size: 16px;
}

.container-mobile .content {
  width: 100vw;
}
.container-mobile .content .text-title {
  font-size: 22px;
  margin: 20px 0;
}
.container-mobile .content .text-date {
  font-size: 16px;
  padding-left: 10px;
}
.container-mobile .content .al-container .img-v {
  max-width: 100vw;
  width: auto;
}
.container-mobile .content .content-v {
  padding: 10px;
}

.container-mobile .logo .left {
  display: flex;
  align-items: center;
}
.container-mobile .logo .left .img-a {
  display: flex;
  align-items: center;
}
.container-mobile .logo {
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/view/news.vue